export const hasPermission = (currentPermissions, permissionsNeeded) => {
  const matchedPermissions = currentPermissions.filter((permissionTheyHave) =>
    permissionsNeeded.includes(permissionTheyHave)
  )
  return matchedPermissions.length > 0
}
